import Request1 from 'assets/Request/request1.avif'
import Request2 from 'assets/Request/request2.avif'
import Request3 from 'assets/Request/request3.avif'
import Request4 from 'assets/Request/request4.avif'
import Request5 from 'assets/Request/request5.avif'
import Request6 from 'assets/Request/request6.avif'

import Request1Mo from 'assets/Request/request1Mo.avif'
import Request2Mo from 'assets/Request/request2Mo.avif'
import Request3Mo from 'assets/Request/request3Mo.avif'
import Request4Mo from 'assets/Request/request4Mo.avif'
import Request5Mo from 'assets/Request/request5Mo.avif'
import Request6Mo from 'assets/Request/request6Mo.avif'

export const requestData = [
    {
        id: 0,
        background: Request1,
        backgroundMo: Request1Mo,
        title: '애플리케이션',
        titleEn: 'Application',
        description: [
            '서비스의 기본 정의부터 사용자 인터페이스를 고려한',
            '최소화 UX 설계를 바탕으로 고객과의 끊임없는 소통을 통해',
            '성공적인 결과물을 만들어 드립니다.'
        ],
        list: [
            '1. 원소스를 통한 IOS, ANDROID 빌드 제공',
            '2. 젊은 감각의 트렌디한 디자인 제공',
            '3. 브랜드 컨셉 분석 후 기획 설계 반영',
            '4. 테스트 환경부터 철저한 제품 QA를 통해 퀄리티 보장'
        ]
    },
    {
        id: 1,
        background: Request2,
        backgroundMo: Request2Mo,
        title: '웹',
        titleEn: 'Web',
        description: [
            '웹 서비스는 다양한 플랫폼과 장치에서 원활히 작동하도록 최적화된 환경을 제공하며,',
            '효율적인 UI설계를 통해 고객이 원하는 결과를 효과적으로 구현합니다.',
            '프로젝트 과정에서 고객과의 소통을 통해 최적의 웹 솔루션을 제공합니다.'
        ],
        list: [
            '1. 반응형 디자인과 크로스 브라우징 최적화를 통해 다양한 장치 및 브라우저에서 일관된 환경 제공',
            '2. 최신 웹 트렌드를 반영한 세련되고 혁신적인 디자인 제공',
            '3. 브랜드 컨셉을 기반으로 유지보수 및 운영 목표를 기확하고 관리',
            '4. 개발 전후 QA를 통해 웹 선능과 보안성을 검증'
        ]
    },
    {
        id: 2,
        background: Request3,
        backgroundMo: Request3Mo,
        title: '블록체인',
        titleEn: 'Blockchain',
        description: [
            '블록체인 기반 프로젝트는 다양한 스마트 컨트랙트와 고도화된',
            '데이터베이스 설계를 통해 관리 효율성이 뛰어난 솔루션을 제공하며,',
            '높은 보안성과 투명성을 보장합니다.'
        ],
        list: [
            '1. 스마트 계약과 블록체인 기반 인증 기술로 보안 강화',
            '2. 블록체인 서비스 트렌드에 맞춘 맞춤형 솔루션 제공',
            '3. 메인넷부터 자체 네트워크 설계까지 유연한 개발 지원'
        ]
    },
    {
        id: 3,
        background: Request4,
        backgroundMo: Request4Mo,
        title: '메타버스',
        titleEn: 'Metaverse',
        description: [
            '메타버스 프로젝트는 생동감 넘치는 가상 환경을 제공하여 사용자들이',
            '직관적이고 쉽게 탐색할 수 있도록 UI / UX를 최적화합니다.또한 브랜드 컨셉과',
            '주요 기능을 효과적으로 전달하면서, 고객의 목표에 맞춘 몰입형 경험을 지원합니다.'
        ],
        list: [
            '1. 다양한 VR / AR 기기와의 호환성을 위해 최적화된 환경제공',
            '2. 3D 및 AR 디자인 서비스 제공',
            '3. 브랜드 컨셉에 맞는 가상 공간 기획 및 설계',
            '4. 가상 공간에서의 사용자 경험을 철저히 QA 테스트하여 특수 효과와 몰입감을 강화'
        ]
    },
    {
        id: 4,
        background: Request5,
        backgroundMo: Request5Mo,
        title: 'IOT',
        titleEn: '사물인터넷, Internet of Things',
        description: [
            'IoT 프로젝트는 다양한 사용자와 유연하게 연결되며, 고객의 요구에 맞춘',
            '데이터 활용 솔루션을 제공합니다.고객의 인터페이스를 빠르게 이해하고 UX 설계를',
            '통해 최적의 사용자 환경을 제공합니다.고객의 피드백을 반영해 IoT 환경을 최적화합니다.'
        ],
        list: [
            '1. 다양한 IoT 네트워크 확장을 통해 사용자 환경 개선',
            '2. 최신 IoT 기술을 반영한 스마트하고 현대적인 설계',
            '3. 고객의 IoT 장치를 중심으로 시스템을 설계',
            '4. 디바이스 및 네트워크 환경에 대한 철저한 QA테스트'
        ]
    },
    {
        id: 5,
        background: Request6,
        backgroundMo: Request6Mo,
        title: '기타업무',
        titleEn: 'Etc',
        description: [
            '프로젝트 유형 카테고리에 원하는 사업내용이 없으시거나,',
            '따로 문의하실 내용이 있으시다면 프로젝트 내용칸에 고객님이 원하는',
            '사업내용을 적어주시면 빠르게 검토후 다시 연락드리겠습니다.'
        ],
        list: [
            '1. 맞춤형 프로젝트 제안',
            '2. 추가 문의 및 상담 서비스',
            '3. 프로젝트 세부 사항 관리 등'
        ]
    },
]